import { App, Plugin } from 'vue';

export interface CacheUtil {
  $setCache: (key: string, value: object) => void;
  $getCache: (key: string) => object;
}

export const CacheUtil: Plugin = {
  install: (app: App) => {
    app.config.globalProperties.$setCache = (key: string, value: object) => {
      if (value == null || value == undefined) return;
      return localStorage.setItem(key, JSON.stringify(value));
    };
    app.config.globalProperties.$getCache = (key: string) => {
      if (key == null || key == undefined) return;
      const cache = localStorage.getItem(key);
      if (cache == null || cache == undefined) return;
      return JSON.parse(cache);
    };
  },
};
